// store/slices/referralOrderLoaderSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isReferralOrderLoading: false,
};

const referralOrderLoaderSlice = createSlice({
  name: "referralOrderLoader",
  initialState,
  reducers: {
    setReferralOrderLoading: (state, action) => {
      state.isReferralOrderLoading = action.payload;
    },
  },
});

export const { setReferralOrderLoading } = referralOrderLoaderSlice.actions;

export default referralOrderLoaderSlice.reducer;
